import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col flex-grow max-w-[72rem]" }
const _hoisted_2 = { class: "h4" }
const _hoisted_3 = { class: "opacity-60" }
const _hoisted_4 = { class: "mt-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _createElementVNode("h1", _hoisted_2, _toDisplayString(_ctx.$props.title), 1),
    _createElementVNode("h3", _hoisted_3, _toDisplayString(_ctx.$props.subtitle), 1),
    _createElementVNode("section", _hoisted_4, [
      _renderSlot(_ctx.$slots, "default")
    ])
  ]))
}